export const EVENT_STATUSES = {
  DRAFT: 'Draft',
  RETURNED: 'Returned',
  IN_REVIEW: 'In Review',
  DELETED: 'Deleted',
  PUBLISHED: 'Published',
  SCHEDULED: 'Scheduled',
  RESTORE: 'Restore',
  EXPIRED: 'Expired',
};
